import { CSSProperties, HTMLAttributes } from 'react';
import { cn } from '@shared/utils/utils';

interface ProgressProps extends HTMLAttributes<HTMLDivElement> {
  value: number;
  max?: number;
  className?: string;
  indicatorClassName?: string;
  indicatorStyle?: CSSProperties;
}

export const Progress = ({
  value,
  max = 100,
  className,
  indicatorClassName,
  indicatorStyle,
  ...props
}: ProgressProps) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  return (
    <div className={cn('relative h-2 w-full overflow-hidden rounded-full bg-muted', className)} {...props}>
      <div
        className={cn('h-full bg-primary transition-all duration-300 ease-in-out', indicatorClassName)}
        style={{ width: `${percentage}%`, ...indicatorStyle }}
      />
    </div>
  );
};
